import React, { useMemo } from "react";
import clsx from "clsx";

import { Context } from "../../../../../../teacherStore";
import { IActiveLearningIssue } from "../../../../../../state";
import { getStudentAnswersByQuestion } from "../../../../../../libs/ActiveLearning";
import AnswerStats from "../../../../../../atoms/ActiveLearning/AnswerStats";
import StudentAnswer from "../../../../../../molecules/ActiveLearning/StudentAnswer";
import styles from "../../../ActiveLearningIssue.module.scss";
import stylesAnswer from "../../../ActiveLearningAnswer.module.scss";

type Issue2AnswerProps = {
  materialCode: string;
  lessonNo: number;
  issue?: IActiveLearningIssue | undefined;
};

export const Issue2Answer = (props: Issue2AnswerProps) => {
  const { state } = React.useContext(Context);
  const currentIssueNo = 2;

  const question = useMemo(() => {
    return props.issue?.questions.find(q => q.order_num === 1);
  }, [props.issue?.questions]);

  const answersSortedByStudentName = useMemo(() => {
    return state.active_learning_answers?.sort((a, b) => {
      return a.last_name_kana.localeCompare(b.last_name_kana, "ja");
    });
  }, [state.active_learning_answers]);

  const studentAnswersQ1 = useMemo(() => {
    return answersSortedByStudentName?.map(studentAnswers => {
      const filteredAnswers = getStudentAnswersByQuestion(
        props.materialCode,
        studentAnswers,
        props.lessonNo,
        currentIssueNo,
        1,
      );

      return {
        ...studentAnswers,
        answers: filteredAnswers,
      };
    });
  }, [answersSortedByStudentName, props.materialCode, props.lessonNo]);

  const studentAnswerStatsQ1 = useMemo(() => {
    const answered =
      studentAnswersQ1?.filter(
        studentAnswers => studentAnswers.answers.length > 0,
      ).length || 0;
    const total = studentAnswersQ1?.length || 0;
    const unanswered = total - answered;

    return {
      answered,
      total,
      unanswered,
    };
  }, [studentAnswersQ1]);

  return (
    <div key={props.issue?.no} className={styles.issue}>
      <div className={clsx(styles.question, styles.primary)}>
        <div className={styles.header}>
          <span className={styles.no}>
            WORK
            {props.issue?.no && props.issue?.no < 10
              ? `0${props.issue?.no}`
              : props.issue?.no}
          </span>
          <p className={styles.title}>{props.issue?.title}</p>
          <AnswerStats
            answered={studentAnswerStatsQ1.answered}
            total={studentAnswerStatsQ1.total}
            unanswered={studentAnswerStatsQ1.unanswered}
          />
        </div>
        {question && (
          <div className={styles.answersArea}>
            {studentAnswersQ1?.map((studentAnswers, index) => {
              const no = index + 1;
              const displayNo = no < 10 ? `0${no}` : `${no}`;
              const isAnswered = studentAnswers.answers.length > 0;
              return (
                <StudentAnswer
                  key={studentAnswers.student_id}
                  isAnswered={isAnswered}
                  no={displayNo}
                  name={`${studentAnswers.last_name} ${studentAnswers.first_name}`}
                  classId={studentAnswers.class_id}
                  studentId={studentAnswers.student_id}
                >
                  {isAnswered &&
                    studentAnswers.answers.map(answer => (
                      <p key={answer.id} className={stylesAnswer.answer}>
                        {answer.contents.value}
                      </p>
                    ))}
                </StudentAnswer>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};
export default Issue2Answer;
